import React, {
  useCallback,
  useEffect,
  useMemo, useState
} from 'react';
import { Button, TextArea } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';
import { formatMessage } from 'devextreme/localization';
import PopupMVP from '../PopupMVP';
import style from './popupactmvp.module.scss';

const PopupActMVP = ({
  popupActReducer: {
    error,
    errorMessage,
    errorTechInfo,
    loading,
    visible,
    title,
    type,
    idAct,
    statusId,
    okRequest,
    note,
    okNote,
    numberAct,
    newFormed
  },
  userReducer: {
    permissions,
    id
  },
  popupActClose,
  getPopupActReport,
  getPopupActErrorClose,
  getAdminActUpdate,
  getIncomingUpdate,
  getShipmentUpdate,
  getTnListUpdate,
  getShipmentClear,
  modalErrorOpen,
  isUseM4,
  isUseAZH,
  popupActGetNote,
  popupActAddNote,
  popupSetNewFormed
}) => {
  const [noteText, setNoteText] = useState(null);
  const [readOnlyPerm, setReadOnlyPerm] = useState(false);
  const [visibleBailorSendAct, setVisibleBailorSendAct] = useState(false);

  useEffect(() => {
    if (error === true) {
      modalErrorOpen({
        message: errorMessage,
        techInfo: errorTechInfo,
        types: 'error',
        title: formatMessage('error')
      });
      getPopupActErrorClose();
    }
  }, [error, errorMessage, errorTechInfo, getPopupActErrorClose, modalErrorOpen]);

  useEffect(() => {
    if (okRequest === true) {
      const savedTabSelect = Number(localStorage.getItem('tabSelect'));
      setTimeout(() => {
        // eslint-disable-next-line default-case
        switch (savedTabSelect) {
          case 0:
            getShipmentUpdate();
            break;
          case 1:
            getIncomingUpdate();
            break;
          case 6:
            getAdminActUpdate();
            break;
          case 12:
            getTnListUpdate();
            break;
        }
        popupActClose();
      }, 4000);
    }
  }, [
    getShipmentClear,
    getAdminActUpdate,
    getIncomingUpdate,
    getShipmentUpdate,
    getTnListUpdate,
    okRequest,
    popupActClose
  ]);

  useEffect(() => {
    if (okRequest && statusId === 2) {
      notify(
        {
          message: type === 'tn' ? formatMessage('textSuccess') : formatMessage('textActSendSuccess'),
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
    }
  }, [okRequest, statusId, type]);

  useEffect(() => {
    if (idAct) {
      popupActGetNote({ idAct });
    }
  }, [
    idAct,
    popupActGetNote
  ]);

  useEffect(() => {
    setNoteText(note);
    setReadOnlyPerm(() => permissions.length === 0 || (permissions.length === 1 && permissions.includes('btnDecision')));
  }, [setNoteText, note, setReadOnlyPerm, permissions]);
  // Функция закрытия основного окна
  const modalOnHiding = useCallback(() => {
    popupActClose();
  }, [popupActClose]);

  /** Сообщение об успешном сохранении особых отметок */
  useEffect(() => {
    if (okNote) {
      notify(
        {
          message: formatMessage('textModal').noteTextSave,
          height: 64,
          width: 354,
          position: {
            at: 'top center',
            my: 'top center',
            offset: '0 48'
          }
        },
        'success',
        2000
      );
      // modalOnHiding();
    }
  }, [okNote]);

  useEffect(() => {
    if (newFormed && !loading && type !== 'tn' && statusId !== 3 && statusId !== 4) {
      setVisibleBailorSendAct(true);
    }
  }, [loading, newFormed, statusId, type]);

  // Основная функция обработки запроса на формирование и отправку акта
  const onTaskPopupAct = useCallback(() => {
    const tempStatus = (statusId === 2 ? 3 : statusId);
    if (type === 'mh1') {
      getPopupActReport({ idAct, statusId: tempStatus, docType: 1 });
    }
    if (type === 'm4') {
      getPopupActReport({ idAct, statusId: tempStatus, docType: 2 });
    }
    if (type === 'mh3') {
      getPopupActReport({ idAct, statusId: tempStatus, docType: 3 });
    }
    if (type === 'm15') {
      getPopupActReport({ idAct, statusId: tempStatus, docType: 15 });
    }
    if (type === 'm15B') {
      getPopupActReport({ idAct, statusId: tempStatus, docType: 15 });
    }
    if (type === 'tn') {
      getPopupActReport({ idAct, statusId: tempStatus, docType: 4 });
    }
  }, [getPopupActReport, type, idAct, statusId]);

  const onTaskPopupAct2 = useCallback(() => {
    if (type === 'mh1') {
      getPopupActReport({ idAct, statusId: 2, docType: 1 });
    }
    if (type === 'm4') {
      getPopupActReport({ idAct, statusId: 2, docType: 2 });
    }
    if (type === 'mh3') {
      getPopupActReport({ idAct, statusId: 2, docType: 3 });
    }
    if (type === 'm15') {
      getPopupActReport({ idAct, statusId: 2, docType: 15 });
    }
    if (type === 'm15B') {
      getPopupActReport({ idAct, statusId: 2, docType: 15 });
    }
    if (type === 'tn') {
      getPopupActReport({ idAct, statusId: 2, docType: 4 });
    }
  }, [getPopupActReport, type, idAct]);

  // Сохранение комментария
  const onClickSave = useCallback(() => {
    popupActAddNote({
      idAct,
      noteText
    });
  }, [
    idAct,
    noteText,
    popupActAddNote
  ]);

  const onSign = useCallback(() => {
    if (type === 'mh1') {
      getPopupActReport({ idAct, statusId: 3, docType: 1 });
    } else if (type === 'mh3') {
      getPopupActReport({ idAct, statusId: 3, docType: 3 });
    } else if (type === 'm4') {
      getPopupActReport({ idAct, statusId: 3, docType: 2 });
    } else if (type === 'm15') {
      getPopupActReport({ idAct, statusId: 3, docType: 15 });
    } else if (type === 'm15B') {
      getPopupActReport({ idAct, statusId: 3, docType: 15 });
    }

    setVisibleBailorSendAct(false);
  }, [getPopupActReport, idAct, type]);

  const onCancel = useCallback(() => {
    setVisibleBailorSendAct(false);
    modalErrorOpen({
      message: `${formatMessage('textModal').textBailorNotSigned} №${numberAct}`,
      techInfo: '',
      types: 'error',
      title: formatMessage('textError').warning
    });
    modalOnHiding();
  }, [modalErrorOpen, modalOnHiding, numberAct]);

  const onHidingBailorSendAct = useCallback(() => {
    onCancel();
    setVisibleBailorSendAct(false);
    popupSetNewFormed(false);
  }, [onCancel, popupSetNewFormed]);

  // Функция рендеринга
  const buttonRender = useMemo(() => {
    if (statusId === 3) {
      return (
        <div className="formButton">
          <>
            <Button text={formatMessage('textButton').preview}
                    type="default"
                    stylingMode="contained"
                    width={200}
                    onClick={onTaskPopupAct2}
            >
              <LoadIndicator className="indicator" visible={statusId === 2 && loading} />
              <span>{formatMessage('textButton').preview}</span>
            </Button>
          </>
          <Button type="default"
                  stylingMode="contained"
                  width={200}
                  onClick={onTaskPopupAct}
                  visible={false}
                  disabled={readOnlyPerm}
          >
            <LoadIndicator className="indicator" visible={statusId === 3 && loading} />
            <span>{formatMessage('textButton').send}</span>
          </Button>
          <Button text={formatMessage('textButton').close}
                  type="default"
                  stylingMode="text"
                  onClick={modalOnHiding}
          />
        </div>
      );
    }
    if (statusId === 2) {
      return (
        <div className="formButton">
          <>
            <Button text={formatMessage('textButton').preview}
                    type="default"
                    stylingMode="contained"
                    width={200}
                    onClick={onTaskPopupAct2}
            />
          </>
          <>
            <Button text={formatMessage('textButton').no}
                    type="default"
                    stylingMode="text"
                    onClick={modalOnHiding}
            />
          </>
          <Button type="default"
                  stylingMode="contained"
                  width={200}
                  onClick={onTaskPopupAct}
                  visible
                  disabled={readOnlyPerm}
          >
            <LoadIndicator className="indicator" visible={loading} />
            <span>{formatMessage('textButton').yes}</span>
          </Button>
        </div>
      );
    }
    if (statusId === 4 && type === 'tn') {
      return (
        <div className="formButton">
          <>
            <Button text={formatMessage('textButton').preview}
                    type="default"
                    stylingMode="contained"
                    width={200}
                    onClick={onTaskPopupAct2}
            />
          </>
          <>
            <Button text={formatMessage('textButton').no}
                    type="default"
                    stylingMode="text"
                    onClick={modalOnHiding}
            />
          </>
        </div>
      )
    }
    if ((statusId === 1 || statusId === 2) && ((!isUseM4 && type === 'mh1') || (type === 'mh3' && !isUseAZH))) {
      return (
        <div>
          <div className={style.comment}>
            <span>{formatMessage('textModal').noteText}</span>
            <TextArea height={80}
                      stylingMode="outlined"
                      value={noteText}
                      onValueChanged={({ value }) => {
                        setNoteText(value);
                      }}
                      disabled={readOnlyPerm}
            />
            <div className="divButton">
              <Button type="default"
                      stylingMode="contained"
                      onClick={onClickSave}
                      text={formatMessage('textButton').save}
                      disabled={readOnlyPerm}
              />
            </div>
          </div>
          <div className="formButton">
            <>
              <Button text={formatMessage('textButton').preview}
                      type="default"
                      stylingMode="contained"
                      width={200}
                      onClick={onTaskPopupAct2}
              />
            </>
            <>
              <Button text={formatMessage('textButton').no}
                      type="default"
                      stylingMode="text"
                      onClick={modalOnHiding}
              />
            </>
            <Button type="default"
                    stylingMode="contained"
                    width={200}
                    onClick={onTaskPopupAct}
                    visible
                    disabled={readOnlyPerm}
            >
              <LoadIndicator className="indicator" visible={loading} />
              <span>{formatMessage('textButton').yes}</span>
            </Button>
          </div>
        </div>
      );
    }
    return (
      <div className="formButton">
        <>
          <Button text={formatMessage('textButton').preview}
                  type="default"
                  stylingMode="contained"
                  onClick={onTaskPopupAct2}
                  visible={readOnlyPerm}
          />
          <Button text={formatMessage('textButton').no}
                  type="default"
                  stylingMode="text"
                  onClick={modalOnHiding}
          />
        </>
        <Button type="default"
                stylingMode="contained"
                width={200}
                onClick={onTaskPopupAct}
                visible={!readOnlyPerm}
        >
          <LoadIndicator className="indicator" visible={loading && !readOnlyPerm} />
          <span>{formatMessage('textButton').yes}</span>
        </Button>
      </div>
    );
  }, [
    noteText,
    onClickSave,
    modalOnHiding,
    onTaskPopupAct2,
    onTaskPopupAct,
    loading,
    isUseAZH,
    isUseM4,
    statusId,
    type,
    readOnlyPerm
  ]);

  return (
    <>
      <PopupMVP onHiding={modalOnHiding}
                visible={visible}
                title={title}
                width={780}
      >
        <div className="formData">
          { buttonRender }
        </div>
      </PopupMVP>

      <PopupMVP onHiding={onHidingBailorSendAct}
                visible={visibleBailorSendAct}
                title={`${formatMessage('textModal').textBailorSendInvoice1Left} №${numberAct} ${formatMessage('textModal').textBailorSendInvoice1Right}`}
                width={780}
      >
        <div className="formData">
          <div className="formButton">
            <Button text={formatMessage('textButton').preview}
                      type="default"
                      stylingMode="contained"
                      width={200}
                      onClick={onTaskPopupAct2}
            />
            <Button text={formatMessage('textButton').no}
                      type="default"
                      stylingMode="text"
                      onClick={onHidingBailorSendAct}
            />
            <Button type="default"
                      stylingMode="contained"
                      width={200}
                      onClick={onSign}
                      visible
                      disabled={readOnlyPerm}
            >
              <LoadIndicator className="indicator" visible={loading} />
              <span>{formatMessage('textButton').yes}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
    </>
  );
};

export default PopupActMVP;
